module.exports = __webpack_public_path__ + "static/media/Coinhub.81d0c2ca.svg";